import React, { useState } from "react";
import axios from "axios";
import "../App.css";
import { ToastContainer, toast } from 'react-toastify';

const Login = () => {
  const [data, setData] = useState({ email: "", password: "" });
  const [response, setResponse] = useState(null);

  const [message, setMessage] = useState(null);
  const notify = () => toast("Wow so easy!");
  //const [response, setResponse] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault(); // prevent default GET
    getLogin();
  };

  const getLogin = async () => {
    try {
      const res = await axios.post("/users/login", {
        "email": data.email,
        "password": data.password,
      }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      });
      setResponse(res.data['data']);
      console.log("id"+res.data['msg']);
      setMessage(res.data['msg']);

            if(res.data["result"])
            {
            localStorage.setItem("id",res.data['data'].id);
            localStorage.setItem("name",res.data['data'].name);
            localStorage.setItem("contact",res.data['data'].contact);
            localStorage.setItem("role_id",res.data['data'].role_id);
            toast.success(message)
            window.location.href = "/dashboard";
            }
            else
            {
              setResponse("User Not found");
              toast.error(message)
            }
            //toast.error(message)
      // console.log("name"+res.data['data'].name);
      //console.log("RoleID"+localStorage.getItem("role_id"));
      // console.log("role_id"+res.data['data'].role_id);

      //localStorage.setItem("id",res.data['data'].id);
    } catch (error) {
      console.error(error);
      //setResponse({ error: error});
      console.log(error);
    }
  };

  return (
    <div className="parent-div3214">
      <ToastContainer />
      <div className="login-container">
        <div className="left-panel">
          <h2>Welcome Back</h2>
          <p>Login to continue to your account.</p>
        </div>
        <div className="right-panel">
          <h3 className="mb-4">Sign in</h3>
          <form onSubmit={handleFormSubmit}>
            <div className="form-group">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Email"
                value={data.email}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                name="password"
                className="form-control"
                placeholder="Password"
                value={data.password}
                onChange={handleInputChange}
              />
            </div>
            <button type="submit" className="btn btn-primary btn-login">
              LOGIN
            </button>
            
              <div className="text-end mt-2">
                <pre>{message}</pre>
              </div>
            
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;